import flachdach from '@/content/flachdach'

export default {
  flachdach
}



// WEBPACK FOOTER //
// ./src/content/index.js